// extracted by mini-css-extract-plugin
export default {"location_header":"SettingCurrentLocationModalHeader_location_header__drwGQ","title":"SettingCurrentLocationModalHeader_title__bIPpg"};